import type { IActionableReportState } from '@/store/modules/report/actionable-report/types';

export const state: IActionableReportState = {
  report: null,
  adaptive_report: null,
};
